<script setup lang="ts">
import { DialogTitle, type DialogTitleProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<DialogTitleProps & { class?: string }>()
</script>

<template>
    <DialogTitle
        v-bind="props"
        :class="
            cn('text-lg text-foreground font-semibold leading-none tracking-tight', props.class)
        "
    >
        <slot />
    </DialogTitle>
</template>
